import { Component, ElementRef, Renderer2, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Menu } from '../../../core/models/menu.model';
import { NavService } from '../../../core/services/nav.service';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { NotificationService } from '../../../core/services/notification.service';
import { Notification } from '../../../core/models/notification.model';
import { getInformerDisplayName } from '../../../core/utils/display-name.util';
import { formatNotificationDateTimeParts } from '../../../core/utils/date-time.util';
import { formatNotificationMessageText } from '../../../core/utils/notification-message.util';
import { Subject, interval, takeUntil } from 'rxjs';
import { InboxService } from '../../../core/services/inbox.service';
import { InboxNotificationItem } from '../../../core/models/inbox.model';
interface Item {
  id: number;
  name: string;
  type: string;
  title: string;
  // Add other properties as needed
}
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit, OnDestroy {
  cartItemCount: number = 5;
  public unreadCount = 0;
  public inboxUnreadCount = 0;
  public notifications: Notification[] = [];
  public inboxNotifications: InboxNotificationItem[] = [];
  public canUseInbox = false;
  private questionnaireUnread = 0;
  private inboxUnread = -1;
  public isCollapsed = true;
  public currentUser: any = null;
  public loading = false;
  public isColaborador = false;
  public isInformador = false;
  public isAdmin = false;
  
  private destroy$ = new Subject<void>();

  @ViewChild('notificationsDropdownRoot') private notificationsDropdownRoot?: ElementRef<HTMLElement>;
  @ViewChild('inboxDropdownRoot') private inboxDropdownRoot?: ElementRef<HTMLElement>;

  constructor(
    public navServices: NavService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private router: Router,
    private notificationService: NotificationService,
    private inboxService: InboxService,
    private authService: AuthService
  ) {
    this.loadCurrentUser();
  }
  isFullScreen = false;
  fullScreenIconVisible = true;
  exitFullScreenIconVisible = false;

  toggleFullScreen() {
    this.isFullScreen = !this.isFullScreen;
    this.fullScreenIconVisible = !this.isFullScreen;
    this.exitFullScreenIconVisible = this.isFullScreen;
  }
  themeChange(type: string, type1: string,type2:string) {
    this.elementRef.nativeElement.ownerDocument.documentElement?.setAttribute('class', type);
    this.elementRef.nativeElement.ownerDocument.documentElement?.setAttribute('style', "");
    localStorage.removeItem("ynex-background-mode-body");
    localStorage.removeItem("ynex-background-mode-dark");
    localStorage.setItem('ynex-theme-mode', type);
    this.elementRef.nativeElement.ownerDocument.documentElement?.setAttribute('data-header-styles', type1);
    localStorage.setItem('ynex-header-mode', type1);
    this.elementRef.nativeElement.ownerDocument.documentElement?.setAttribute('data-menu-styles', type2);
    localStorage.setItem('ynex-menu-mode', type2);
    const htmlElement = this.elementRef.nativeElement.ownerDocument.documentElement;

    if (type == 'dark') {
      const darkbtn = document.querySelector(
        '#switcher-dark-theme'
      ) as HTMLInputElement;
      darkbtn.checked = true;
      this.renderer.setAttribute(htmlElement, 'data-menu-style','dark');

    } else {
      const lightbtn = document.querySelector(
        '#switcher-light-theme'
      ) as HTMLInputElement;
      lightbtn.checked = true;
      this.renderer.setAttribute(htmlElement, 'data-menu-style','light');

    }
  }
  toggleSidebar() {
    let html = this.elementRef.nativeElement.ownerDocument.documentElement;
    // const windowObject: any = window;
    if (localStorage.getItem('data-toggled') == 'true') {
      document.querySelector('html')?.getAttribute('data-toggled') ==
        'icon-overlay-close';
    } else if (html?.getAttribute('data-vertical-style') == 'overlay') {
      document.querySelector('html')?.getAttribute('data-toggled') != null
        ? document.querySelector('html')?.removeAttribute('data-toggled')
        : document
            .querySelector('html')
            ?.setAttribute('data-toggled', 'icon-overlay-close');
    } else if (localStorage.getItem('ynex-sidemenu-styles') == 'closed') {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'close-menu-close'
          ? ''
          : 'close-menu-close'
      );
    } else if (localStorage.getItem('ynex-sidemenu-styles') == 'icontext') {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'icon-text-close'
          ? ''
          : 'icon-text-close'
      );
    } else if (localStorage.getItem('ynex-sidemenu-styles') == 'detached') {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'detached-close'
          ? ''
          : 'detached-close'
      );
    } else if (localStorage.getItem('ynex-sidemenu-styles') == 'doublemenu') {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'double-menu-close'
          ? 'double-menu-open'
          : 'double-menu-close'
      );

      // document.querySelector('.slide-menu')?.classList.add('double-menu-active');
    }
   
    if (window.innerWidth <= 992) {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'open' ? 'close' : 'open'
      );
      if (html?.getAttribute('data-toggled') == 'open') {
        document.querySelector('#responsive-overlay')?.classList.add('active');
      }
    }
  }
    // Search
    public menuItems!: Menu[];
    public items!: Menu[];
    public text!: string;
    public SearchResultEmpty:boolean = false;
    ngOnInit() {
      this.navServices.items.subscribe((menuItems) => {
        this.items = menuItems;
      });

      this.startNotificationPollingIfNeeded();
      this.startInboxPollingIfNeeded();
    }
  
  Search(searchText: string) {
    if (!searchText) return this.menuItems = [];
    // items array which stores the elements
    const items:Item[] = [];
    // Converting the text to lower case by using toLowerCase() and trim() used to remove the spaces from starting and ending
    searchText = searchText.toLowerCase().trim();
    this.items.filter((menuItems:Menu) => {
      // checking whether menuItems having title property, if there was no title property it will return
      if (!menuItems?.title) return false;
      //  checking wheteher menuitems type is text or string and checking the titles of menuitems
      if (menuItems.type === 'link' && menuItems.title.toLowerCase().includes(searchText)) {
        // Converting the menuitems title to lowercase and checking whether title is starting with same text of searchText
        if( menuItems.title.toLowerCase().startsWith(searchText)){ // If you want to get all the data with matching to letter entered remove this line(condition and leave items.push(menuItems))
          // If both are matching then the code is pushed to items array
          items.push(menuItems as Item);
        }
      }
      //  checking whether the menuItems having children property or not if there was no children the return
      if (!menuItems.children) return false;
      menuItems.children.filter((subItems:Menu) => {
        if (!subItems?.title) return false; 
        if (subItems.type === 'link' && subItems.title.toLowerCase().includes(searchText)) {
          if( subItems.title.toLowerCase().startsWith(searchText)){         // If you want to get all the data with matching to letter entered remove this line(condition and leave items.push(subItems))
            items.push(subItems as Item);
          }

        }
        if (!subItems.children) return false;
        subItems.children.filter((subSubItems:Menu) => {
          if (subSubItems.title?.toLowerCase().includes(searchText)) {
            if( subSubItems.title.toLowerCase().startsWith(searchText)){ // If you want to get all the data with matching to letter entered remove this line(condition and leave items.push(subSubItems))
              items.push(subSubItems as Item);
              
            }
          }
        });
        return true;
      });
      return this.menuItems = items;
    });
    // Used to show the No search result found box if the length of the items is 0
    if(!items.length){
      this.SearchResultEmpty = true;
    }
    else{
      this.SearchResultEmpty = false;
    }
    return true;
  }

  //  Used to clear previous search result
  clearSearch() {    
    this.text = '';
    this.menuItems = [];
    this.SearchResultEmpty = false;
    return this.text, this.menuItems;
  }
  isCartEmpty: boolean = false;

  removeRow(rowId: string) {
    const rowElement = document.getElementById(rowId);
    if (rowElement) {
      rowElement.remove();

      
    }
    this.cartItemCount--;
    this.isCartEmpty = this.cartItemCount === 0;
  }
  removeTags(rowId: string) {
    const rowElement = document.getElementById(rowId);
    if (rowElement) {
      rowElement.remove();
    }
  }

  /**
   * Carrega notificações recentes ao abrir o dropdown
   */
  public onNotificationsDropdownOpen(): void {
    this.notificationService.loadRecentNotifications(15);
  }

  /**
   * Navega para o questionário da notificação
   * @param notification Notificação selecionada
   */
  public onInboxDropdownOpen(): void {
    this.pollInboxNotifications();
  }

  public onInboxNotificationClick(notification: InboxNotificationItem, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.inboxService.markNotificationRead(notification.id).subscribe({ error: () => undefined });
    void this.router.navigate(['/inbox'], { queryParams: { conversation: notification.conversation_id } });
    this.closeInboxDropdown();
  }

  public closeInboxDropdown(): void {
    const el = this.inboxDropdownRoot?.nativeElement;
    if (!el?.classList.contains('open')) {
      return;
    }
    const hs = (window as { HSDropdown?: { close: (element: HTMLElement, force?: boolean) => void } }).HSDropdown;
    if (hs && typeof hs.close === 'function') {
      hs.close(el, true);
    }
  }

  private pollInboxNotifications(): void {
    this.inboxService.getNotifications().subscribe({
      next: ({ items, unreadCount }) => {
        const viewingInbox = this.router.url.startsWith('/inbox');
        if (this.inboxUnread >= 0 && unreadCount > this.inboxUnread && !viewingInbox) {
          this.playInboxTone();
        }
        this.inboxUnread = unreadCount;
        this.inboxUnreadCount = unreadCount;
        // Dropdown do admin: apenas as 5 mais recentes
        this.inboxNotifications = items.slice(0, 5);
      },
      error: () => undefined,
    });
  }

  private playInboxTone(): void {
    const audio = new Audio('assets/live-chat-sound-effect.mp3');
    audio.volume = 0.7;
    void audio.play().catch(() => undefined);
  }

  public onNotificationClick(notification: Notification, event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    const navigate = (): void => {
      const { metadata } = notification;

      if (this.notificationService.shouldNavigateToProcessGroups(notification)) {
        this.router.navigate(['/admin/groups'], {
          queryParams: {
            process_id: metadata.process_id,
            page: 1,
            per_page: 12
          }
        });
        return;
      }

      this.router.navigate(
        ['/admin/informers/view/group', metadata.group_id, 'questionnaire', metadata.questionnaire_id],
        {
          queryParams: {
            process_id: metadata.process_id,
            informer_id: metadata.informer_id
          }
        }
      );
    };

    this.closeNotificationsDropdown();
    navigate();
  }

  /**
   * Fecha o dropdown ao acessar a listagem completa
   */
  public onViewAllNotificationsClick(): void {
    this.closeNotificationsDropdown();
  }

  /**
   * Marca todas as notificações como lidas
   */
  public onMarkAllNotificationsRead(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    this.notificationService.markAllAsRead()
      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }

  /**
   * Verifica se a notificação não foi lida
   * @param notification Notificação
   */
  public isNotificationUnread(notification: Notification): boolean {
    return !notification.read_at;
  }

  /**
   * Verifica se a notificação possui metadados para mensagem detalhada
   * @param notification Notificação
   */
  public hasDetailedNotificationMessage(notification: Notification): boolean {
    const { metadata } = notification;

    return !!(
      metadata.informer_name &&
      metadata.questionnaire_name &&
      metadata.group_name &&
      metadata.process_name
    );
  }

  /**
   * Retorna a linha da data da notificação (dia da semana + data)
   * @param value Data da notificação
   */
  public getNotificationDateLine(value: string): string {
    return formatNotificationDateTimeParts(value).dateLine;
  }

  /**
   * Retorna a linha do horário da notificação
   * @param value Data da notificação
   */
  public getNotificationTimeLine(value: string): string {
    return formatNotificationDateTimeParts(value).timeLine;
  }

  /**
   * Normaliza mensagem simples em minúsculas com ponto final
   * @param message Texto da mensagem
   */
  public getNotificationMessageText(message: string): string {
    return formatNotificationMessageText(message);
  }

  handleCardClick(event: MouseEvent) {
    // Prevent the click event from propagating to the container
    event.stopPropagation();
  }

  shouldShowSidebarToggle(): boolean {
    const url = this.router.url;
    return !url.startsWith('/protocol') && !url.startsWith('/painel');
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private closeNotificationsDropdown(): void {
    const el = this.notificationsDropdownRoot?.nativeElement;
    if (!el?.classList.contains('open')) {
      return;
    }

    const hs = (window as { HSDropdown?: { close: (element: HTMLElement, force?: boolean) => void } }).HSDropdown;
    if (hs && typeof hs.close === 'function') {
      hs.close(el, true);
    }
  }

  private loadCurrentUser(): void {
    this.authService.authState$
      .pipe(takeUntil(this.destroy$))
      .subscribe(authState => {
        this.currentUser = authState.user;
        this.isColaborador = this.authService.isColaborador();
        this.isInformador = this.authService.isInformador();
        this.isAdmin = this.authService.isAdmin();
        this.canUseInbox = this.isAdmin || this.isInformador;
        this.startNotificationPollingIfNeeded();
        this.startInboxPollingIfNeeded();
      });
  }

  private notificationPollingStarted = false;
  private inboxPollingStarted = false;

  private startNotificationPollingIfNeeded(): void {
    if (!this.isAdmin || this.notificationPollingStarted || !this.authService.canViewNotifications()) {
      return;
    }
    this.notificationPollingStarted = true;
    this.notificationService.startPolling();
    this.notificationService.loadRecentNotifications(15);
    this.notificationService.unreadCount$
      .pipe(takeUntil(this.destroy$))
      .subscribe((count) => {
        this.questionnaireUnread = count;
        this.unreadCount = this.questionnaireUnread;
      });
    this.notificationService.notifications$
      .pipe(takeUntil(this.destroy$))
      .subscribe((notifications) => {
        this.notifications = notifications;
      });
  }

  private startInboxPollingIfNeeded(): void {
    if (!this.canUseInbox || this.inboxPollingStarted) {
      return;
    }
    this.inboxPollingStarted = true;
    this.pollInboxNotifications();
    interval(8000).pipe(takeUntil(this.destroy$)).subscribe(() => this.pollInboxNotifications());
  }

  public getProfileLink(): string {
    if (this.authService.isInformador()) {
      return '/protocol/profile';
    }

    if (this.authService.isSuperAdmin()) {
      return '/painel/profile';
    }

    return '/admin/profile';
  }

  public getCurrentUserDisplayName(): string {
    if (!this.currentUser) {
      return '';
    }

    return getInformerDisplayName({
      first_name: this.currentUser.first_name,
      last_name: this.currentUser.last_name,
      display_name: this.currentUser.display_name,
      religious_institution_abbreviation: this.currentUser.informer?.religious_institution_abbreviation
    });
  }

  public onLogout(): void {
    if (this.loading) {
      return;
    }

    this.loading = true;
    
    this.authService.logout()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.loading = false;
          if (response.success) {
            this.router.navigate(['/auth/login']);
          }
        },
        error: (error) => {
          this.loading = false;
          console.error('Erro ao fazer logout:', error);
          // Mesmo com erro, redireciona para login por segurança
          this.router.navigate(['/auth/login']);
        }
      });
  }
}
